import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { NavigationOrigins, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useExistingEquipment } from "../../hooks/queries/equipment/useEquipments"

export const EquipmentValidator = (props) => {
    const { children } = props

    const { road, code, signId: equipmentId } = useParams()
    const navigate = useNavigateWithSearchParams()

    const navigateBack = useCallback(() => {
        navigate(code ? `../${road}/code/${code}` : `../${road}`, { navigationOrigin: NavigationOrigins.NONE })
    }, [code, navigate, road])

    const existingEquipment = useExistingEquipment(equipmentId, navigateBack)

    if (!existingEquipment) {
        return null
    }

    return children
}